/**
 * @request dmp请求方法
 * @author kevinjwwu <kevinjwwu@tencent.com>
 */

import { dmpParams } from '../store/dmp'
import { publicParams } from '../store'
import { stringify, getUrlParam, getScript } from '../utils'
import { titleHandler, sourceIdHandler } from '../utils/dmp'

function reportDmp( {
	action, // 用户行为：visit（进入微社区上报），pop（曝光），click（点击），pv（内容详情页访问上报），timeline（内容详情页离开上报），leave（离开微社区上报），watch（观赛时长上报）
	channelid = '', // 频道 ID，记录频道名称，如：王者世界
	from = 'ingame', // 来源：tgl，v4，ingame, middle_level
	path = '', // 访问路径，离开微社区时上报用户完整路径，如：#/heroBook/139,#/heroBook/12
	recid = '', // 推荐 id，如使用了推荐算法，记录推荐规则 id，如：rc02
	sourceid = '', // 上报的来源 id，四级路由 + 自定义标识，如：index.0.0.0.list
	staytime = 0, // 停留时长，内容详情页离开上报页面停留时长，离开微社区上报微社区访问时长，单位：秒
	tag = '', // 目标标签
	targettype = '', // 目标类型：news（资讯），video（视频），picture（图片），person（用户）
	title = '', // 目标标题
	targetid = '', // 操作的目标 id
	top = false, // 是否置顶，true / false
	hash = ''   // 路由地址，只在timeline用到
}) {
	// 如果没有传入sourceid，则取hash值作为sourceid
	if (!sourceid) sourceid = sourceIdHandler(hash)

	// 只允许曝光上报批量
	if (action.indexOf('pop') === -1 && String(targetid).indexOf(',') !== -1) return

	// 处理标题特殊编码
	title = titleHandler(title, targetid)

	let pageid = location.origin + location.pathname + location.hash

	if (action.indexOf('leave') != -1) {
		staytime = Number(new Date()) - dmpParams.time_pv_begin
		path = dmpParams.list_visited_path.join(',')
	}
	
	// 判断安卓ios环境
	let platid = 1
	if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
		platid = 0
	}

	// 判断手Q/微信环境
	let adtag = getUrlParam('adtag', publicParams.searchUrl), openid = publicParams.searchObj.openid || ''
	if (/MicroMessenger/i.test(navigator.userAgent)) {
		adtag = 'plat_wx'
	}
	if (/QQ\//i.test(navigator.userAgent)) {
		adtag = 'plat_qq'
		openid = getUrlParam('uin', publicParams.searchUrl)
	}
	
	getAxios().then(()=>{
		let parasStr = `${ publicParams.game }|${ publicParams.searchObj.acctype||'' }|${ platid }|${ openid }|${ publicParams.searchObj.partition||'' }|${ publicParams.searchObj.roleid||'' }|${ pageid }|${ sourceid }|${ action }|${ targetid }|${ targettype }|${ tag }|${ title }|${ from }|${ Date.now() }|${ adtag }|${ staytime }|${ path }|${ recid }|${ channelid }|${ top }`
		console.log(``)
		console.log(`dmp上报${action}成功，参数${parasStr}`)
		console.log(``)
		
		return window.axios({
			method: 'POST',
			url: '//app.ingame.qq.com/gingame/report/tdbank',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			data: stringify({
				business: 'dmp',
				data: parasStr
			})
		})
	})
	
}

function reportDmpPop() {
	// 参数处理
	let pop_list = dmpParams.list_dmp_multi_pop.slice(0)
	if (!pop_list.length) return
	dmpParams.list_dmp_multi_pop = []
	let params = pop_list[0]
	params.action = 'pop'
	params.targetid = pop_list.map(item => item.targetid).join(dmpParams.MULTI_SPLITER)
	params.title = pop_list.map(item => item.title).join(dmpParams.MULTI_SPLITER)
	// params.tag = pop_list.map((item) => {item.tag}).join(';')
	reportDmp(params)
}

// 特殊按钮上报
function reportDmpBtn([tag1 ,tag2 ,tag3, action = 'click']) {
	let params = {
		action,
		targettype: 'button',
		tag:`${tag1}.${tag2}.${tag3}`,
	}
	reportDmp(params)
}

function getAxios() {
	return new Promise( (resolve, reject) => {
		if (!window.axios) {
			getScript('//tiem-cdn.qq.com/slugteam/libraries/axios/axios@0.18.min.js').then(()=>{
				resolve()
			})
		} else {
			resolve()
		}
	} )
}

export { reportDmp, reportDmpPop, getAxios, reportDmpBtn }